export default {
    Metadata: {
        Name: "isDirtyColumn",
        Description: "Returns true if the <column> has unsaved data changes.",
        Syntax: "IsDirtyColumn(<columnUID>)",
        Keywords: ['Logical'],
        Author: "DataVoke, Inc.",
    },
    execute(gv) {
        if (gv == null) {
            return false;
        }
        else {
            return gv.isDirty();
        }
    },
};

